import React, { useContext,useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import  Box  from "@material-ui/core/Box";
import LoginButton from "../../Login/loginButton";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { WebContext } from "../../../../Utility";
import Search from "../../navbarSearch";
import SocialMediaLinks from "../../Commons/SocialMediaLinks";
import { NAVBAR_EXTERNAL_LINKS } from "../../../../Constants";
import { DesktopMenuDropdown } from "../mobileNavbar";
const useStyles = makeStyles((theme) => ({
  navbar: {
    background: "transparent",
    width: "100%",
    position: "absolute",
    top: 0,
    zIndex: 1,
  },
  navLink: {
     color: theme.agentTheme.card.link_foreground,
  },
  navBarContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1, 4),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
  navBarLogo: {
    margin: "auto 0px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& img": {
      width: "100%",
      objectFit: "contain",
    },
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
  },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: 'transparent',
    height: 40,
  },
  navBarText: {
    padding: "0px 5px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  navBarTextContainer: {
    marginRight: 20,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  navIcon: {
    margin: "auto 0px",
    color: theme.agentTheme.primary?.main,
    zIndex: 1,
  },
  navIconNonTransparent: {
    color: theme.agentTheme.primary?.main,
  },
  nav: {
    backgroundColor: 'transparent',
    position: "relative",
    boxShadow: "1px 3px 12px rgba(0, 0, 0, 0.08)",
  },
  navTextHover: {
    "&:hover": {
      transform: "scale(0.9)",
      transition: "all 300ms ease-in-out 10ms",
      color: theme.agentTheme.primary.main,
    },
    "&$activeNavItem": {
      transform: "scale(0.9)",
      transition: "all 300ms ease-in-out 10ms",
      color: theme.agentTheme.primary.main,
    },
  },
  activeNavItem: {
    backgroundColor: "transparent",
    color: theme.agentTheme.primary.foreground,
  },
  searchDiv: {
    margin: "auto 8px",
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
  },
  activeMobileItem: {
    color: theme.agentTheme.primary.main,
  },
  socialMediaContainer: {
    width: "25%",
    display: "flex",
    alignItems: "center",
  },
  loginButton: {
    marginTop: "6px",
    color: theme.agentTheme.primary.main,
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));

export default (props) => {
  let {
    logo_url = "",
    contentArr = [],
    username = "",
    getLogoUrl,
    isMobile = false,
    toggleMenu: mobileNavBarOpen = false,
    memberProfile,
    onNavIconClick,
        handleCovidMenuClose,
    handleCovidMenuItemClick,
    loginItem,
  } = props || {};
  const { social_media_links = [] } = memberProfile;
  const classes = useStyles();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
  const { website_modules: websiteModules = {} } = memberProfile || {};
  const { packages: isPackagesEnabled = true } = websiteModules || {};
    const [isLoginMenu, setIsLoginMenu] = useState(false);
       const [anchorEl, setAnchorEl] = useState(null);
         const [clickItem, setClickItem] = useState([]);
   const handleCovidMenuClick = (
      event,
      clickItemParam = [],
      islogin = false
    ) => {
      setIsLoginMenu(islogin);
      if (clickItemParam.length > 0) setClickItem(clickItemParam);
      if (anchorEl == null) setAnchorEl(event.currentTarget);
      else handleCovidMenuClose();
    };

  const getNavItem = () => {
    return (
      <>
        {contentArr.map((item) => {
          let showActive = false;
          if (location.pathname == item.link) showActive = true;
          else if (location.pathname == "/" && item.link == `/${username}`)
            showActive = true;
          else if (item.clickHandle) {
            item.clickItem.map((element) => {
              if (
                element.link == location.pathname ||
                element.link.pathname == location.pathname
              )
                showActive = true;
            });
          }
          if (mobileNavBarOpen) {
          } else {
            if (item.clickHandle) {
              return (
                <>
                  <div
                    className={`${classes.navTextHover} ${
                      classes.navBarTextContainer
                    } ${showActive && classes.activeNavItem} ${
                      classes.navLink
                    }`}
                    onClick={(e) => handleCovidMenuClick(e, item.clickItem)}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label} {item.dropdown && <KeyboardArrowDown />}
                    </Typography>
                  </div>
                </>
              );
            } else {
              const isExternalLink = NAVBAR_EXTERNAL_LINKS.includes(
                item.label.toLowerCase()
              );
              return isExternalLink ? (
                <a href={item.link} className={classes.navLink}>
                  <div
                    className={`${classes.navTextHover} ${
                      classes.navBarTextContainer
                    } ${
                      location.pathname == item.link && classes.activeNavItem
                    }`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </a>
              ) : (
                <NavLink
                  to={{
                    pathname: item.link,
                    hash: item.hash || "",
                    state: { memberProfileData: memberProfile },
                  }}
                  className={classes.navLink}
                >
                  <div
                    className={`${classes.navTextHover} ${
                      classes.navBarTextContainer
                    } ${
                      location.pathname == item.link && classes.activeNavItem
                    }`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </NavLink>
              );
            }
          }
        })}
      </>
    );
  };
  return (
    <div className={`${classes.navbar} ${classes.nav}`}>
      <Container maxWidth={false} className={classes.navBarContainer}>
        <div className={classes.navBarLogo}>
          {!isMobile && (
            <div className={classes.socialMediaContainer}>
              <SocialMediaLinks social_media_links={social_media_links} />
            </div>
          )}
          {isMobile && (
            <div
              className={`${classes.navIcon} ${
                !mobileNavBarOpen && classes.navIconNonTransparent
              }`}
            >
              {!mobileNavBarOpen ? (
                <MenuIcon onClick={onNavIconClick} />
              ) : (
                <CloseIcon onClick={onNavIconClick} />
              )}
            </div>
          )}
          {!isMobile && (
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              width={"100%"}
            >
              {isPackagesEnabled && (
                <div className={classes.searchDiv}>
                  <Search type="NAVBAR_SEARCH_2" />
                </div>
              )}
              <Box
                onClick={(e) => isLoggedIn && handleCovidMenuClick(e, [], true)}
              >
                <LoginButton loginClass={classes.loginButton} />
              </Box>
            </Box>
          )}
        </div>
        {isMobile && logo_url && (
          <Link to={`/${username ? `${username}` : ""}`}>
            <img src={getLogoUrl(logo_url)} height="70" />
          </Link>
        )}
        {isMobile && <LoginButton loginClass={classes.loginButton} />}
        {!isMobile && logo_url && (
          <Link to={`/${username ? `${username}` : ""}`}>
            <img src={getLogoUrl(logo_url)} height="70" />
          </Link>
        )}
      </Container>
      <div>
        {!isMobile && (
          <div className={classes.navBarContent}>{getNavItem()}</div>
        )}
      </div>  {(isLoginMenu || clickItem.length > 0) && (
                          <DesktopMenuDropdown
                            anchorEl={anchorEl}
                            handleCovidMenuClose={handleCovidMenuClose}
                            loginMenu={isLoginMenu}
                            clickItem={isLoginMenu ? loginItem : clickItem}
                            handleCovidMenuItemClick={handleCovidMenuItemClick}
                          />
                        )}

    </div>
  );
};
